'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.customer.service
 * @description
 * # customer.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .service('CustomerService', function(BaseService, errorService) {

    var service = new BaseService();
    service.GetAll = GetAll;
    service.GetById = GetById;
    service.Create = Create;
    service.Update = Update;
    service.Delete = Delete;
    service.AddHome = AddHome;
    service.getOrders = getOrders;
    service.getHome = getHome;
    service.updateHome = updateHome;

    return service;

    function GetAll() {
    return service.http.get(service.baseUrl + '/customers')
        .then(handleSuccess)
        .catch(handleError);
    }

    function GetById(id) {
      var includeHomes = true;
      return service.http.get(service.baseUrl + '/customers/' + id + '?includeHomes=' + includeHomes)
      .then(handleSuccess)
      .catch(handleError);
    }

    function Create(customer) {
      return service.http.post(service.baseUrl + '/customers', customer)
      .then(handleSuccess)
      .catch(handleError);
    }

    function Update(customer) {
      return service.http.put(service.baseUrl + '/customers/' + customer.id, customer)
      .then(handleSuccess)
      .catch(handleError);
    }

    function Delete(id) {
      return service.http.delete(service.baseUrl + '/customers/' + id)
      .then(handleSuccess)
      .catch(handleError);
    }

    function AddHome(home) {
      return service.http.post(service.baseUrl + '/homes', home)
      .then(handleSuccess)
      .catch(handleError);
    }

    function getHome(id) {
      return service.http.get(service.baseUrl + '/homes/' + id)
      .then(handleSuccess)
      .catch(handleError);
    }

    function updateHome(home) {
      return service.http.put(service.baseUrl + '/homes/' + home.id, home)
      .then(handleSuccess)
      .catch(handleError);
    }

    function getOrders(customerId, homeId) {
      var ordersUrl = service.baseUrl + '/customers/' + customerId + '/orders';
      ordersUrl = !!homeId ? ordersUrl + '?homeId=' + homeId : ordersUrl;
      return service.http.get(ordersUrl)
      .then(handleSuccess)
      .catch(handleError);
    }


    function handleSuccess(response) {
     return response.data;
    }

    function handleError(error, status) {
      return service.q.reject(errorService.handleError(error));
    }
  });
